export default __webpack_public_path__ + "static/media/semsPortalZh.a2d3df0b.png";